import { Th, Thead, Tr } from '@chakra-ui/react'

interface RegimensTableHeadProps {
  lists: {
    label: string
    fieldId: string
    items: { [itemId: string]: string }
    id: string
  }[]
  amountEnabled?: boolean
  frequencyEnabled?: boolean
  durationEnabled?: boolean
  methodEnabled?: boolean
  percentageEnabled?: boolean
}

export default function RegimensTableHead({
  lists,
  amountEnabled,
  frequencyEnabled,
  durationEnabled,
  methodEnabled,
  percentageEnabled,
}: RegimensTableHeadProps) {
  if (lists[0].id === 'dentalProcedures') {
    return (
      <Thead>
        <Tr>
          <Th></Th>
          <Th>Procedure Date</Th>
          <Th>{lists[0].label}</Th>
        </Tr>
      </Thead>
    )
  }

  return (
    <Thead>
      <Tr>
        <Th></Th>
        <Th>Start</Th>
        <Th>End</Th>
        {lists.map((list) => (
          <Th key={`th-${list.fieldId}`}>{list.label}</Th>
        ))}
        {percentageEnabled && <Th>Percentage</Th>}
        {amountEnabled && <Th>Amount</Th>}
        {durationEnabled && <Th>Duration</Th>}
        {frequencyEnabled && <Th>Frequency</Th>}
        {methodEnabled && <Th>Method</Th>}
      </Tr>
    </Thead>
  )
}
